import { render, staticRenderFns } from "./OpenTasks.vue?vue&type=template&id=70733a20&scoped=true&"
import script from "./OpenTasks.vue?vue&type=script&lang=js&"
export * from "./OpenTasks.vue?vue&type=script&lang=js&"
import style0 from "./OpenTasks.vue?vue&type=style&index=0&id=70733a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70733a20",
  null
  
)

export default component.exports